const name = require("./name");
const regex = require("./regex");

const dictionaryUtil = {};

dictionaryUtil.blacklist = {
  name: {
    exact: ["_"],
    loose: [name.main],
  },
};

dictionaryUtil.preset = {
  password: {
    type: "string",
    minLength: 6,
    maxLength: 500,
    regex: [regex.whitespace],
  },
};

dictionaryUtil.get = (dictionaryConfigs) => (id, prop) => {
  for (let dictionaryConfig of dictionaryConfigs)
    if (dictionaryConfig.key === id || dictionaryConfig.label === id)
      return prop ? dictionaryConfig[prop] : dictionaryConfig;
  return prop ? null : {};
};

module.exports = dictionaryUtil;
